import { LogOut, Moon, Sun } from 'lucide-react'
import leapMark from '@/assets/favicon.png'
import { useAuthStore } from '@/stores/authStore'
import { isPodTransporter } from '@/utils/authPaths'
import { transporterDocumentJourneyPath } from '@/utils/transporterNav'
import { useAppStore } from '@/app/store'
import { Button } from '@/components/ui/Button'
import { useNavigate } from 'react-router-dom'
import { LanguageSwitcher } from './LanguageSwitcher'
import { useTranslation } from 'react-i18next'

export function Header() {
  const { t } = useTranslation(['Header'])
  const { user, logout } = useAuthStore()
  const navigate = useNavigate()
  const isTransporter = isPodTransporter(user)

  const handleLogout = () => {
    void logout()
  }
  const { toggleSidebar, theme, setTheme } = useAppStore()

  return (
    <header className="sticky top-0 z-30 flex items-center justify-between gap-3 border-b border-border bg-background/80 px-6 py-4 backdrop-blur">
      <div className="flex min-w-0 items-center gap-3">
        <button
          type="button"
          onClick={toggleSidebar}
          className="inline-flex shrink-0 items-center justify-center rounded-md p-1.5 text-muted-foreground hover:bg-muted hover:text-foreground transition-colors md:hidden"
          aria-label="Toggle sidebar"
        >
          <img src={leapMark} alt="" width={22} height={22} className="size-[22px] object-contain" />
        </button>
        <div className="min-w-0">
          <div className="text-lg font-semibold text-foreground truncate">{t('Header:general.appName', 'LEAP · POD')}</div>
          <div className="hidden text-sm text-muted-foreground md:block">{t('Header:general.appSubtitle', 'Proof of Delivery')}</div>
        </div>
      </div>

      <div className="flex shrink-0 items-center gap-3">
        <div className="hidden sm:flex flex-col items-end leading-tight">
          <div className="max-w-[14rem] truncate text-sm font-medium text-foreground">
            {user?.name ?? '—'}
          </div>
          <div className="max-w-[14rem] truncate text-xs text-muted-foreground">
            {user?.email ?? user?.role ?? ''}
          </div>
        </div>

        <LanguageSwitcher />

        <Button
          variant="outline"
          size="icon"
          className="shrink-0"
          onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
          aria-label="Toggle theme"
        >
          {theme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </Button>

        <Button
          variant="outline"
          className="hidden sm:inline-flex shrink-0"
          onClick={() =>
            navigate(isTransporter ? transporterDocumentJourneyPath() : '/documentJourney')
          }
        >
          {t('Header:general.documentJourney', 'Document Journey')}
        </Button>

        <Button variant="outline" className="shrink-0 gap-2 text-sm" onClick={handleLogout}>
          <LogOut className="h-4 w-4" />
          {t('Header:general.logout', 'Logout')}
        </Button>
      </div>
    </header>
  )
}
